// External
import { Component, OnInit, Output, Input, ElementRef, ViewChild, AfterContentInit, HostListener, EventEmitter } from '@angular/core';

// Internal

const heightAnimationTime = 250;

@Component({
  selector: 'ui-panel',
  exportAs: 'uiPanel',
  template: `<div class="panel-content">
              <div class="panel-header" [ngClass]="caret ? 'caret-'+ caret : ''" tabindex="0"
              (keydown.enter)="collapsePanel($event)"
              (click)="collapsePanel($event)">
                <span class="caret connect_icon_left" *ngIf="caret && expandable"></span><ng-content select="[panel-header]"></ng-content>
              </div>
              <div class="panel-body" 
                   *ngIf="expandable" 
                    [ngClass]="{'open': collapsed}" [style.visibility]="collapsed ? 'visible': 'hidden'"
                    [style.minHeight.px]="panelHeight" #panelBody>
                <div #panelBodyContent><ng-content select="[panel-body]"></ng-content></div>
            </div>
            </div>`,
  host: {
    '[class.panel]' : 'true',
    '[class.collapsed]': 'collapsed',
    '[class.expandable]': 'expandable'
  }
})
export class UiPanelComponent implements OnInit, AfterContentInit {

    @Input() scrollOnExpand = true;ß
    @Input() caret = 'right';
    @Input() collapsed = false;
    @Input() expandable = true;
    @ViewChild('panelBodyContent', {read: ElementRef}) panelBodyContent: ElementRef;
    @Output() toggle: EventEmitter<any> = new EventEmitter<any>();
    
    panelHeight: number;

    constructor(readonly el: ElementRef) { }

    ngOnInit() {
    }

    collapsePanel(event) {
        // stopping click from bubbling
        // event.stopPropagation();
        this.collapsed ? this.closePanel() : this.openPanel();
    }

    ngAfterContentInit() {
        this.panelHeight =  this.collapsed ? this.panelBodyContent.nativeElement.offsetHeight : 0;
    }

    closePanel() {
        if(!this.expandable) {
            return;
        }
        this.collapsed = false;
        this.panelHeight = 0;
    }

    openPanel() {
        if(!this.expandable) {
            return;
        }
        this.collapsed = true;
        this.panelHeight =  this.panelBodyContent.nativeElement.offsetHeight;
        this.toggle.emit();

        if(this.scrollOnExpand){
            setTimeout(()=>{
                this.el.nativeElement.scrollIntoView({behavior: "smooth", block: "start"});
            }, heightAnimationTime);
        }
    }

}
